import React, { useState } from 'react';
import BasesTable from './BasesTable/BasesTable';
import DeleteConfirmation from './DeleteConfirmation/DeleteConfirmation';
import { BasesListProps } from '../../types/base';

const BasesList: React.FC<BasesListProps> = ({
  bases,
  isAdmin,
  onSaveChanges,
  onDelete,
  onAddToCart,
  onDeleteFromCart,
  addedToCartIds = [],
  isLoading = false,
  onScroll,
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedBase, setSelectedBase] = useState<{
    id: number;
    title: string;
  } | null>(null);

  const handleDeleteClick = (id: number, title: string) => {
    setSelectedBase({ id, title });
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedBase && onDelete) {
      onDelete(selectedBase.id, selectedBase.title);
    }
    setDeleteDialogOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <>
      <BasesTable
        bases={bases}
        isAdmin={isAdmin}
        isLoading={isLoading}
        addedToCartIds={addedToCartIds}
        onAddToCart={onAddToCart}
        onDeleteFromCart={onDeleteFromCart}
        onSaveChanges={onSaveChanges}
        onDelete={handleDeleteClick}
        onScroll={onScroll}
      />

      <DeleteConfirmation
        open={deleteDialogOpen}
        baseTitle={selectedBase?.title}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </>
  );
};

export default BasesList;
